import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";

// CSS
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Take the full height of the viewport
        boxSizing: 'border-box', // Include padding/border in height calculations
    },
    content: {
        flex: 1, // Take all available space
        overflow: 'auto', // Enable scrolling if content overflows
    },
    bottomNavigation: {
        backgroundColor: theme.palette.background.paper,
        position: 'sticky', // Ensure it stays at the bottom
        bottom: 0, // Stick to the bottom of the container
        zIndex: 1, // Ensure it stays above other content
    },
}));

// Menu Item
export interface IMenuItem {
    label: string;
    icon: React.ReactNode;
    onClick?: () => void;
}

// All the incoming values
interface IProps {
    menuItems: IMenuItem[];
    selectedIndex?: number;
    children?: React.ReactNode;
}

// Outgoing functions
interface IDispatch {
    onChange?: (item: IMenuItem) => void;
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const SubNavigation = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const [value, setValue] = React.useState(props.selectedIndex);

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                {props.children}
            </div>
            <BottomNavigation
                className={classes.bottomNavigation}
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    const item = props.menuItems[newValue];
                    item.onClick && item.onClick();
                    props.onChange && props.onChange(item);
                }}
                showLabels
            >
                {props.menuItems.map((item, index) => (
                    <BottomNavigationAction
                        key={index}
                        label={item.label}
                        icon={item.icon}
                    />
                ))}
            </BottomNavigation>
        </div>
    );
};